import { EntityName } from 'record-it-time-common/EntityName';
import { useEntitiesChangedListener } from '../useEntitiesChangedListener/useEntitiesChangedListener';

export function useEntityChangedListener(
  entityName: EntityName,
  callback: () => void
): void {
  useEntitiesChangedListener([entityName], callback);
}
